import { StartWithUnit } from '@core/state/operators/start-with-unit';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataTransferService } from '@api/services/data-transfer.service';
import { LoadaDataRequest } from '@api/models/DataTransfer/Contract/loada-data-request';
import { startWithLoading } from '@core/state/operators/start-with-loading';
import { LoadDataResponse } from '@api/models/DataTransfer/Contract/load-data-response';
import { CustomRxState } from '@core/state/rx.state';


interface ILoadDataState {
    loading: Record<StartWithUnit, boolean>;
}

@Injectable()
export class LoadDataState extends CustomRxState<ILoadDataState> {
    readonly #dataTransferService: DataTransferService = inject(DataTransferService);

    public readonly loading$: Observable<Record<StartWithUnit, boolean>> = this.select('loading');

    public loadData(body: LoadaDataRequest): Observable<LoadDataResponse[]> {
        return this.#dataTransferService.apiDataTransferTransferDataToDwhPost({ body }).pipe(
            startWithLoading(this, StartWithUnit.LoadData),
        );
    }

    constructor() {
        super();
        this.setDefaultState();
    }

    private setDefaultState(): void {
        this.set({
            loading: null,
        });
    }
}
